import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  FormattedNumber,
  FormattedDate,
} from 'react-intl';

// === Messages === //
// Add a '<span>' to allow rich text formatting on a single line
export const LocalizedMessage = React.memo(({
  className, style, paragraph, ...props
}) => {
  if (paragraph) {
    return (
      <p className={className} style={style}>
        <FormattedMessage {...props} />
      </p>
    );
  }

  return (
    <span className={className} style={style}>
      <FormattedMessage {...props} />
    </span>
  );
});
LocalizedMessage.propTypes = {
  paragraph: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};
LocalizedMessage.defaultProps = {
  paragraph: false,
  className: '',
  style: {},
};
LocalizedMessage.displayName = 'LocalizedMessage';

// === Numbers === //
export const LocalizedPrice = React.memo(({ currency, ...otherProps }) => (
  <FormattedNumber style="currency" currency={currency} {...otherProps} />
));
LocalizedPrice.displayName = 'LocalizedPrice';
LocalizedPrice.propTypes = {
  currency: PropTypes.string.isRequired,
};

// === Percentage === //
export const LocalizedPercentage = React.memo(({ percentage }) => (
  <FormattedNumber style="percent" value={percentage / 100} maximumFractionDigits="2" />
));
LocalizedPercentage.displayName = 'LocalizedPercentage';
LocalizedPercentage.propTypes = {
  percentage: PropTypes.number.isRequired,
};

// === Date and time === //
export const standardDateOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
};

export const LocalizedStandardDate = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateOptions}
  />
));
LocalizedStandardDate.displayName = 'LocalizedStandardDate';

export const standardDateNoSecondsOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const LocalizedStandardDateNoSeconds = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateNoSecondsOptions}
  />
));
LocalizedStandardDateNoSeconds.displayName = 'LocalizedStandardDateNoSeconds';

export const standardDateNoTimeOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

export const LocalizedStandardDateNoTime = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateNoTimeOptions}
  />
));
LocalizedStandardDateNoTime.displayName = 'LocalizedStandardDateNoTime';

export const standardDateDayMonthOptions = {
  month: 'numeric',
  day: 'numeric',
};

export const LocalizedStandardDateDayMonth = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateDayMonthOptions}
  />
));
LocalizedStandardDateDayMonth.displayName = 'LocalizedStandardDateDayMonth';

export const standardDateMonthYearOptions = {
  year: 'numeric',
  month: 'numeric',
};

export const LocalizedStandardDateMonthYear = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateMonthYearOptions}
  />
));
LocalizedStandardDateMonthYear.displayName = 'LocalizedStandardDateMonthYear';

export const standardDateYearOptions = {
  year: 'numeric',
};

export const LocalizedStandardDateYear = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardDateYearOptions}
  />
));
LocalizedStandardDateYear.displayName = 'LocalizedStandardDateYear';

export const standardTimeOptions = {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
};

export const LocalizedStandardTime = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardTimeOptions}
  />
));
LocalizedStandardTime.displayName = 'LocalizedStandardTime';

export const standardTimeNoSecondsOptions = {
  hour: 'numeric',
  minute: 'numeric',
};

export const LocalizedStandardTimeNoSeconds = React.memo((props) => (
  <FormattedDate
    {...props}
    {...standardTimeNoSecondsOptions}
  />
));
LocalizedStandardTimeNoSeconds.displayName = 'LocalizedStandardTimeNoSeconds';



// WEBPACK FOOTER //
// ./intl/LocalizedComponents.js